import { RootState } from 'features/store';
import { getUser, logout } from 'features/auth';
import { useDispatch, useSelector } from 'react-redux';

export const useHeaderVM = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => getUser(state));

    const handleLogout = () => {
        dispatch(logout());
    };

    return {
        user,
        handleLogout
    };
};
